module.exports = __webpack_public_path__ + "static/media/super-img-2.93f5d085.png";